import { AbstractStorage } from "@clairejs/client";
import { getServiceProvider, AbstractConstructor } from "@clairejs/core";
import { useRef } from "react";
import { useLanguage, useStore as useStoreData, useDispatch as useStoreDispatch } from "@clairejs/react";

import { DataStore } from "../store/store";

import { ErrorHandler } from "../utils/error-handler";
import { LANG_STORAGE_KEY } from "../helpers/constants";

export const useErrorHandler = () => {
    const handler = useInject(ErrorHandler);

    return handler;
};

export const useInject = <T,>(cls: AbstractConstructor<T>) => {
    const instance = useRef(getServiceProvider().getInjector().resolve(cls));
    return instance.current as T;
};

export const useSetLanguage = () => {
    const storage = useInject(AbstractStorage);

    const [lang, setLang] = useLanguage();

    const setLanguage = async (code: string) => {
        setLang(code);
        await storage.setItem(LANG_STORAGE_KEY, code);
    };

    return { lang, setLanguage };
};

export const useStore = <T,>(selector: (store: DataStore) => T) => {
    return useStoreData(DataStore, selector);
};

export const useDispatch = <T,>(selector?: (store: DataStore) => T) => {
    return useStoreDispatch(DataStore, selector);
};
